module.exports = __webpack_public_path__ + "img/nothing.62740881.png";